module.exports = __webpack_public_path__ + "img/nz.03019028.svg";